<template>
  <div
    :style="{
      ...containerStyle,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }"
  >
    <!-- สำหรับทำ BG -->
    <div
      :style="{
        ...containerBgStyle,
        position: 'absolute',
        zIndex: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundPositionX: 'center',
      }"
    ></div>

    <!-- Float -->
    <!-- Top -->
    <FloatTop
      v-if="isShowFloatTop"
      pageName="MicrositeHistory"
      :campaign="campaign"
      :isShowRedirectHome="isShowFloatTop"
    />
    <!-- Bottom -->
    <FloatBottom pageName="MicrositeHistory" :campaign="campaign" />

    <Survey
      v-if="survey"
      :survey="survey"
      style="height: fit-content; z-index: 1"
      :style="{
        paddingTop: isShowFloatTop ? '52px' : '0px',
      }"
    ></Survey>

    <div class="w-100 d-flex justify-center pa-6">
      <v-card
        class="w-100 d-flex flex-column justify-center align-center table-show"
        style="padding: 24px 0px; z-index: 1"
        rounded="xl"
      >
        <h2 class="text-center font-weight-medium">
          {{ $t("microsite.textRegistrationHistory") }}
        </h2>
        <v-card class="mt-4 px-4 py-1" rounded="lg" elevation="0">
          <!-- <h4>
            Your cumulative total
            {{ campaign.top_spender_type == "amount" ? "amount" : "point" }} :

            {{
              campaign.top_spender_type == "amount"
                ? user.total_summary_amount
                  ? user.total_summary_amount.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : "-"
                : user.total_point
                ? user.total_point.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : "-"
            }}
          </h4> -->
          <h4 class="pa-2">
            <span v-if="show_type != 'amount'">
              {{ $t("microsite.textTotalPoint") }} :
              <span data-testid="total-point-value">
                {{
                  user.total_point?.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </span>
            <span class="mx-2" v-if="show_type == 'all'">/</span>
            <span v-if="show_type != 'point'">
              {{ $t("microsite.textTotalAmount") }} :
              <span data-testid="total-amount-value">
                {{
                  user.total_summary_amount?.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </span>
          </h4>
        </v-card>
        <v-card
          class="table-container mx-auto mt-4"
          rounded="lg"
          flat
          color="transparent"
        >
          <v-simple-table
            data-testid="table-transaction-history"
            class="mx-auto"
          >
            <thead class="text-center">
              <tr>
                <th
                  v-for="(header, index) in table.headers"
                  :key="index"
                  class="pa-2 text-center"
                >
                  {{ formatHeader(header) }}
                </th>
              </tr>
            </thead>

            <tbody class="text-center">
              <tr v-for="(item, index) in history" :key="index" class="pa-2">
                <td
                  v-for="(header, headerIndex) in table.headers"
                  :key="headerIndex"
                  class="pa-2"
                >
                  <template v-if="header.value === 'status'">
                    <div class="d-flex mx-auto" style="cursor: pointer">
                      <v-chip
                        :data-testid="'transaction-status-' + item.status"
                        :color="getStatusColor(item.status)"
                        dark
                        small
                        class="mx-auto"
                      >
                        {{ getStatusText(item.status) }}
                      </v-chip>
                    </div>
                    <div v-if="item.statusDetail && item.status == 'Rejected'">
                      <p>{{ item.statusDetail }}</p>
                    </div>
                  </template>
                  <template v-else-if="header.value === 'amount'">
                    <div class="text-center">
                      {{
                        item && item.amount
                          ? item.amount.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "-"
                      }}
                    </div>
                  </template>
                  <template v-else-if="header.value === '#bill_amount'">
                    <div class="text-center">
                      {{
                        item && item["#bill_amount"]
                          ? item["#bill_amount"].toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "-"
                      }}
                    </div>
                  </template>
                  <template v-else-if="isTypeImage(item[header.value])">
                    <v-img
                      :src="item[header.value].content"
                      width="150"
                      :aspect-ratio="16 / 9"
                      contain
                      @click="handleOpenMediaPreview(item[header.value])"
                      class="mx-auto"
                    >
                    </v-img>
                    <div
                      v-if="item[header.value].value"
                      class="text-center mt-2"
                      style="width: 150px"
                    >
                      {{ item[header.value].value }}
                    </div>
                  </template>
                  <template v-else-if="isTypeFile(item[header.value])">
                    <v-img
                      v-if="isMIMEImage(item[header.value].content[0].name)"
                      :src="item[header.value].content[0].content"
                      width="150"
                      :aspect-ratio="16 / 9"
                      contain
                      @click="handleOpenMediaPreview(item[header.value])"
                      class="mx-auto"
                    >
                    </v-img>
                    <v-img
                      v-else-if="
                        isMIMEVideo(item[header.value].content[0].name)
                      "
                      src="https://tru-vue.com/wp-content/uploads/2015/11/video-icon.jpg"
                      width="150"
                      :aspect-ratio="16 / 9"
                      contain
                      @click="handleOpenMediaPreview(item[header.value])"
                      class="mx-auto"
                    >
                    </v-img>
                    <div v-else class="d-flex justify-center">
                      <img
                        src="@/assets/images/svg/document.svg"
                        @click="handleDownloadFile(item[header.value])"
                        class="mx-auto"
                      />
                    </div>
                  </template>
                  <template v-else-if="header.value === 'point'">
                    <span data-testid="point-value">
                      {{
                        item && item.point
                          ? item.point.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "-"
                      }}
                    </span>
                  </template>
                  <template v-else-if="header.value === 'summary_amount'">
                    <span data-testid="summary-amount-value">
                      {{
                        item && item.summary_amount
                          ? item.summary_amount.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "-"
                      }}
                    </span>
                  </template>

                  <template v-else-if="header.value === 'createdAt'">
                    {{ item.createdAt | formatDate }}
                  </template>
                  <template v-else-if="header.value === 'action'">
                    <v-icon color="blue" @click="handleClickStatus(item)"
                      >mdi-eye-outline</v-icon
                    >
                  </template>
                  <template v-else>
                    {{ item[header.value] | formatDataTable }}
                  </template>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>

        <div class="d-flex justify-center px-4 mt-8" style="width: 100%">
          <v-btn
            data-testid="btn-back"
            color="black"
            class="text-center white--text"
            width="100"
            height="40"
            rounded
            @click="handleRedirectMenu"
          >
            {{ $t("microsite.textBack") }}
          </v-btn>

          <v-btn
            v-if="false"
            data-testid="btn-back"
            color="black"
            class="text-center white--text"
            style="width: 100%; border-radius: 8px"
            height="56"
            @click="handleRedirectMenu"
          >
            {{ $t("microsite.textBack") }}
          </v-btn>
          <img
            v-if="false"
            data-testid="btn-back"
            :src="'https://mcommerce-dev-ap-southeast-1-341611064526.s3.ap-southeast-1.amazonaws.com/local/hr-engagement/app/public/priw/microsite/2026-10-16/6COYUICPI2M2E0O_gemini-generated-image-qhovraqhovraqhov-copy.webp'"
            style="
              width: 100%;
              height: auto;
              object-fit: contain;
              box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 8px;
              border-radius: 8px;
            "
            @error="onImageError($event, null, '')"
            @click="handleRedirectMenu"
          />
        </div>
      </v-card>
    </div>

    <v-dialog
      v-if="dialogs.image"
      v-model="dialogs.image"
      max-width="1000px"
      class="dialog-image"
    >
      <v-card>
        <v-row style="position: absolute; top: 0; right: 0; z-index: 100">
          <v-col>
            <v-btn
              text
              icon
              x-large
              height="40"
              width="40"
              color="white"
              @click="dialogs.image = false"
            >
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-card-actions class="pa-0">
          <v-img :src="selectedImage[0].content"></v-img>
          <!-- <p>status : {{ itemStatus }}</p> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog preview image -->
    <v-dialog v-model="dialogs.mediaPreview" persistent max-width="500px">
      <v-card flat class="rounded-0" style="position: relative">
        <v-btn
          class="text-center"
          @click="dialogs.mediaPreview = false"
          fab
          color="white"
          x-small
          style="
            position: absolute;
            top: 8px;
            right: 8px;
            z-index: 1;
            opacity: 0.5;
          "
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-img
          v-if="isMIMEImage(mediaDetail.name)"
          style="z-index: 0"
          :src="mediaDetail.content"
        >
        </v-img>
        <video
          v-else-if="isMIMEVideo(mediaDetail.name)"
          controls
          crossorigin
          playsinline
          data-plyr-config='{ "ratio": "4:3" }'
          width="100%"
        >
          <source :src="mediaDetail.content" type="video/mp4" />
        </video>
        <div v-else></div>
      </v-card>
    </v-dialog>

    <DialogDetail
      v-if="dialogs.detail"
      v-model="dialogs.detail"
      @close="handleCloseChangeStatus"
      @openMediaPreview="handleOpenMediaPreviewByRaw"
      @refresh="handleRefresh"
      :selectedTransaction="selectedTransaction"
      templateName="Survey"
      :registerTemplateJson="registerTemplateJson"
      :campaign="campaign"
    />

    <v-footer padless v-if="campaign.is_show_footer">
      <v-col class="text-center footer" cols="12">
        <p class="ql-editor" v-html="campaign.footer_text"></p>
      </v-col>
    </v-footer>
  </div>
</template>

<script>
import moment from "moment";
import { Model } from "survey-core";
import { mapState } from "vuex";
import { Survey } from "survey-vue-ui";
import "survey-vue/defaultV2.min.css";
import MicrositeAxios from "@/config/microsite-service";
import DialogDetail from "../user/dialog/DialogDetail.vue";
import {
  addClassQlEditorToSDDisplay,
  customThemeSurveyJS,
  transformValueSurvey,
  visibilityTableHeaderQuestion,
} from "../../../config/general-function";
import FloatTop from "./components/float-top.vue";
import FloatBottom from "./components/float-bottom.vue";

export default {
  name: "MicrositeHistory",
  inject: ["isAppLoading"],
  components: {
    Survey,
    DialogDetail,
    FloatTop,
    FloatBottom,
  },
  data: () => ({
    campaign: {
      is_show_footer: false,
    },
    survey: null,
    themeJson: null,
    history: null,
    table: {
      headers: [{ title: "Date", value: "createdAt" }],
    },
    dialogs: {
      image: false,
      itemStatus: "",
      mediaPreview: false,
      detail: false,
    },
    selectedImage: null,
    logoHeight: null,
    mediaDetail: {
      type: "",
      name: "",
      content: "",
    },
    statusDetailList: [
      { text: "อนุมัติ", value: "Approved" },
      { text: "รออนุมัติ", value: "Waiting" },
      { text: "ไม่อนุมัติ", value: "Rejected" },
    ],
    selectedTransaction: null,
    dialogTransaction: false,
    containerStyle: {
      background: "#FFFFFF",
    },
    containerBgStyle: {
      background: "#FFFFFF",
    },
    registerTemplateJson: null,
    show_type: "",

    isHoverableDevice: false,
    activeFloat: null,
    secondClick: false,
  }),
  async created() {
    await this.getCampaign();
    await this.getHistory();
    await this.getSurveyAndTheme();

    this.getHeaderAndHistory();
    if (
      (this.campaign.template_id == 1 || this.campaign.template_id == 2) &&
      this.campaign.split_register_page
    ) {
      this.registerTemplateJson = JSON.parse(this.campaign.survey_json).bill;
    } else {
      this.registerTemplateJson = JSON.parse(
        this.campaign.survey_json
      ).register;
    }

    this.survey = new Model(this.surveyJson);
    this.survey.applyTheme(this.themeJson);
    this.survey.showCompletedPage = false;
    this.setLogoHeight();
    // ========== ========== ========== ==========
    addClassQlEditorToSDDisplay();
  },
  computed: {
    ...mapState("microsite", ["user"]),
    ...mapState("defaultSystem", ["site"]),
    isShowFloatTop() {
      let check = false;
      const token = localStorage.getItem("token");
      const is_sync_customer = this.campaign?.is_sync_customer;
      if (token && is_sync_customer) {
        check = true;
      }
      return check;
    },
  },
  methods: {
    handleRedirectMenu() {
      this.$router.push({
        name: "microsite-menu",
        params: { id: this.$route.params.id },
      });
    },
    handleRefresh() {
      this.$router.go();
    },
    onImageError(event, item, key) {
      if (item && item[key]) {
        item[key] = "";
      } else {
        event.target.style.display = "none";
      }
    },
    async getHistory() {
      try {
        const response = await MicrositeAxios.get(
          `checkPhoneNumber/${this.campaign.id}?phone=${encodeURIComponent(
            this.user.phone
          )}`
        );
        const userExists = response.data.data.users;
        if (userExists) {
          this.$store.commit("microsite/SET_USER", {
            user: {
              phone: userExists ? userExists.phone : this.user.phone,
              fullname: userExists ? userExists.fullname : null,
              line_id: userExists ? userExists.line_id : null,
              detail: userExists ? userExists.detail : null,
              history: userExists ? userExists.campaignTransaction : null,
              status_consent: userExists ? userExists.status_consent : null,
              total_amount: userExists
                ? parseFloat(userExists.total_amount)
                : null,
              total_point: userExists
                ? parseFloat(userExists.total_point)
                : null,
              total_summary_amount: userExists
                ? parseFloat(userExists.total_summary_amount)
                : null,
            },
          });
        } else {
          this.$swal
            .fire({
              icon: "error",
              title: this.$t("microsite.dataNotFound"),
              showConfirmButton: true,
            })
            .then(() => {
              this.$router.push({ name: "microsite-login" });
            });
        }
      } catch (error) {
        this.$swal
          .fire({
            icon: "error",
            title: this.$t("microsite.errGeneral"),
            showConfirmButton: true,
          })
          .then(() => {
            this.$router.push({ name: "microsite-login" });
          });
        console.log(error);
      }
    },
    async getCampaign() {
      try {
        const response = await MicrositeAxios.get(
          `getCampaign/${this.site.id}?slug=${this.$route.params.slug}`
        );

        this.campaign = response.data.data.microsite;

        // ========== ========== History Only ========== ==========
        if (this.campaign.survey_json_flatten) {
          this.campaign.survey_json = this.campaign.survey_json_flatten;
        }
        // ========== ========== ========== ==========
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: "microsite-error",
          params: { slug: this.$route.params.slug },
        });
      }
    },
    getSurveyAndTheme() {
      const surveyJson = JSON.parse(this.campaign.survey_json);
      if (surveyJson && surveyJson.history) {
        this.surveyJson = surveyJson.history;
      } else {
        this.surveyJson = JSON.parse(
          this.campaign.template.default_survey_json
        ).history;
      }

      this.containerStyle = {
        backgroundColor: "#F3F3F3",
      };
      this.containerBgStyle = {
        backgroundColor: "#F3F3F3",
      };
      const themeJson = JSON.parse(this.campaign.theme_json);
      if (themeJson) {
        if (themeJson?.cssVariables) {
          const themeList = Object.keys(themeJson?.cssVariables);
          const _bg = themeList.find((x) => x == "--sjs-general-backcolor-dim");
          if (_bg) {
            this.containerStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            this.containerBgStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            if (themeJson?.backgroundImage) {
              this.containerBgStyle = {
                ...this.containerBgStyle,
                backgroundImage: `url(${themeJson.backgroundImage}`,
                backgroundSize: themeJson.backgroundImageFit,
                backgroundAttachment: themeJson.backgroundImageAttachment,
                opacity: themeJson.backgroundOpacity,
              };
              themeJson.backgroundImage = null;
              themeJson.cssVariables["--sjs-general-backcolor-dim"] =
                "transperent";
            }
          }
        }
        customThemeSurveyJS(themeJson?.cssVariables);
        this.themeJson = themeJson;
      }
    },
    handleClickStatus(data) {
      this.dialogs.detail = true;
      this.selectedTransaction = data;
    },
    getColor(status) {
      if (status === "Approved") {
        return "green";
      } else if (status === "Rejected") {
        return "red";
      } else {
        return "warning";
      }
    },
    handleOpenMediaPreviewByRaw(param) {
      this.mediaDetail.type = "image";
      this.mediaDetail.name = param.name;
      this.mediaDetail.content = param.content;
      this.dialogs.mediaPreview = true;
    },
    handleCloseChangeStatus() {
      this.dialogs.detail = false;
    },
    getHeaderAndHistory() {
      let headers;
      if (
        (this.campaign.template_id == 1 || this.campaign.template_id == 2) &&
        this.campaign.split_register_page
      ) {
        headers = JSON.parse(this.campaign.survey_json).bill;
      } else {
        headers = JSON.parse(this.campaign.survey_json).register;
      }

      let headersElement = headers.elements;

      headersElement.forEach((item) => {
        if (
          item.name !== "fullname" &&
          item.name !== "phone" &&
          item.type !== "image"
        ) {
          this.table.headers.push({
            title: item.title || item.name,
            value: item.name,
          });
        }
      });

      this.show_type = this.campaign.history_type;
      this.show_total_type = this.campaign.history_type;

      // if (
      //   this.campaign.is_use_sum_amount_by_transaction == false &&
      //   this.campaign.is_use_sum_amount == true
      // ) {
      //   this.show_type = "amount";
      // }

      if (this.show_type == "all") {
        this.table.headers.push({
          title: "Summary Amount",
          value: "summary_amount",
        });
        this.table.headers.push({ title: "Point", value: "point" });
      } else if (this.show_type == "amount") {
        this.table.headers.push({
          title: "Summary Amount",
          value: "summary_amount",
        });
      } else if (this.show_type == "point") {
        this.table.headers.push({ title: "Point", value: "point" });
      }

      this.table.headers.push({ title: "Status", value: "status" });
      this.table.headers.push({ title: "Action", value: "action" });

      const history = this.user?.history?.map((item) => {
        const parsedItem = JSON.parse(item.result_json);
        delete parsedItem.fullname;
        delete parsedItem.phone;
        let pointValue = this.show_type != "amount" ? item.point : "-";

        if (
          this.campaign.is_use_sum_amount_by_transaction == false &&
          this.campaign.is_use_sum_amount
        ) {
          pointValue = "-";
        }

        let summaryAmountValue =
          this.show_type != "point" ? item.summary_amount : "-";

        if (
          this.campaign.template_id == 1 &&
          this.campaign.is_use_sum_amount == false
        ) {
          summaryAmountValue = "-";
        }

        return {
          created_at: item.created_at,
          ...parsedItem,
          point: pointValue,
          summary_amount: summaryAmountValue,
          status: item.status,
          statusDetail: item.status_detail,
          result_json: item.result_json,
        };
      });
      this.history = history;

      this.setDataHistory();
    },
    async setDataHistory() {
      // set header
      let headers;
      if (
        (this.campaign.template_id == 1 || this.campaign.template_id == 2) &&
        this.campaign.split_register_page
      ) {
        headers = JSON.parse(this.campaign.survey_json).bill;
      } else {
        headers = JSON.parse(this.campaign.survey_json).register;
      }

      let headersElement = headers.elements;

      // set transaction history
      let _list = [];
      let _results = [];
      if (Array.isArray(this.history)) {
        _list = [...this.history];
      }
      for (let item of _list) {
        let detail = {
          id: item.id,
          status: item.status,
          createdAt: item.created_at,
          point: item.point,
          summary_amount: item.summary_amount,
          statusDetail: item.statusDetail,
        };
        // ========== ========== ========== ==========
        if (Array.isArray(headersElement)) {
          let result_json = {};
          try {
            result_json = JSON.parse(item.result_json);
          } catch {
            console.log("err");
          }

          // ========== ========== ========== ==========
          for (let item of headersElement) {
            let value = result_json[item.name];
            if (
              (item.type == "radiogroup" || item.type === "dropdown") &&
              value == "other"
            ) {
              value = value + "-" + result_json[item.name + "-Comment"];
              delete result_json[item.name + "-Comment"];
            } else if ("checkbox" === item.type && value != undefined) {
              value.forEach((element, index, value) => {
                if (element === "other") {
                  value[index] =
                    value[index] + "-" + result_json[item.name + "-Comment"];
                  delete result_json[item.name + "-Comment"];
                }
              });
            }
            value = transformValueSurvey(value, item);
            result_json[item.name] = value;
          }
          detail = {
            ...detail,
            ...result_json,
          };
        }
        _results.push(detail);
      }
      this.history = [..._results];
      this.table.headers = visibilityTableHeaderQuestion(
        this.table.headers,
        this.history
      );
    },

    setLogoHeight() {
      this.survey.onAfterRenderQuestion.add((_sender, options) => {
        if (options.question.name === "logo") {
          const imageElement =
            options.htmlElement.querySelector(".sd-image__image");
          if (imageElement) {
            const setHeight = () => {
              const height = imageElement.getBoundingClientRect().height;
              this.logoHeight = height + 30;
            };

            if (imageElement.complete) {
              setHeight();
            } else {
              imageElement.addEventListener("load", setHeight);
            }
          }
        }
      });
    },
    previewImage(img, status) {
      this.selectedImage = img;

      this.dialogs.image = true;
      this.itemStatus = status;
    },
    isTypeImage(item) {
      if (item?.type?.includes("image")) {
        this.isContainImage = true;
        return true;
      }
      return false;
    },
    isTypeFile(item) {
      if (item?.type?.includes("file")) {
        return true;
      }
      return false;
    },
    isMIMEImage(link) {
      return /\.(gif|jpe?g|jfif|tiff?|png|webp|bmp|avif|svg)$/i.test(link);
    },
    isMIMEVideo(link) {
      return /\.(mp4|webm|ogg|avi|mov)$/i.test(link);
    },
    handleOpenMediaPreview(param) {
      this.mediaDetail.type = "image";
      if (param.type == "file") {
        this.mediaDetail.name = param.content[0].name;
        this.mediaDetail.content = param.content[0].content;
      } else if (param.type == "image") {
        this.mediaDetail.name = "image.jpg";
        this.mediaDetail.content = param.content;
      }
      this.dialogs.mediaPreview = true;
    },
    getStatusColor(status) {
      const colors = {
        Approved: "green",
        Waiting: "grey",
        Rejected: "red",
      };
      return colors[status] || "grey";
    },

    getStatusText(statusDetail) {
      const text = this.statusDetailList.find(
        (item) => item.value === statusDetail
      );
      const key_lang = `microsite.${text?.value}`;
      return text ? this.$t(key_lang) : "";
      // return text ? text.text : "";
    },
    formatHeader(param) {
      let title = param.title;
      const value = param.value;
      const static_header = [
        "createdAt",
        "summary_amount",
        "point",
        "status",
        "status_detail",
      ];
      if (static_header.includes(value)) {
        const key_lang = `microsite.${value}`;
        title = this.$t(key_lang);
      }
      return title;
    },
    getIconAndColorByStatus(status) {
      if (status === "Approved") {
        return {
          icon: "mdi-check-circle-outline",
          color: "green",
        };
      } else if (status === "Rejected") {
        return {
          icon: "mdi-close-circle-outline",
          color: "red",
        };
      }
      return {
        icon: "mdi-minus-circle-outline",
        color: "grey",
      };
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      const date = moment(value);
      let label = "";
      if (date.year() == moment().year()) {
        label = date.format("DD MMM, HH:mm:ss");
      } else {
        label = date.format("DD MMM YY, HH:mm:ss");
      }
      return label;
    },
    formatDataTable: function (value) {
      if (!value) return "-";
      return value;
    },
  },
};
</script>

<style scoped>
.table-container {
  width: 95%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.dialog-image {
  z-index: 1000;
}

::v-deep .footer p {
  word-break: break-all;
  margin-bottom: 0 !important;
}
::v-deep .v-footer {
  margin-top: auto !important;
  margin-bottom: 0px !important;
}

/* default */
::v-deep .sd-body--empty {
  display: none;
}
::v-deep .sd-body.sd-body--static {
  padding-top: 0px !important;
}
::v-deep .sd-page {
  padding: 0px !important;
}
::v-deep #sv-nav-complete {
  width: 100%;
}
::v-deep .sd-navigation__complete-btn {
  width: 100%;
}
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}
/* add-on */
::v-deep .sd-body {
  padding-bottom: 0px !important;
}
::v-deep .sd-navigation__complete-btn {
  display: none;
}
::v-deep .sd-action-bar {
  display: none;
}
</style>

<style lang="scss" scoped>
::v-deep .sd-file__decorator {
  background-color: var(
    --sjs-editorpanel-backcolor,
    var(
      --sjs-editor-background,
      var(
        --sjs-general-backcolor-dim-light,
        var(--background-dim-light, #f9f9f9)
      )
    )
  );
  border-radius: var(
    --sjs-editorpanel-cornerRadius,
    var(--sjs-corner-radius, 4px)
  );
}
::v-deep .sd-row:first-of-type {
  width: calc(100% + (2 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px))))));
  margin-left: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
  margin-right: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
}
::v-deep .sd-row:first-of-type :is(.sd-image__image:first-of-type) {
  border-radius: 0px;
}
.table-show {
  max-width: calc(90 * (var(--sjs-base-unit, var(--base-unit, 8px))));
}
</style>
